import { Injectable } from '@angular/core';
import { Category } from '../interface/category/category';
import { HttpService } from './http/http.service';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RoutesService {

  constructor(private _http: HttpService) { }

  public get(): Promise<Category[]> {
    return firstValueFrom(this._http.get('/Routes'));
  }
  public getById(id: number): Promise<any> {
    return firstValueFrom(this._http.get(`/Routes/${id}`));
  }
  public add(data: Category): Promise<Category> {
    return firstValueFrom(this._http.post('/Routes', data));
  }
  public update(id: number, data: Category): Promise<Category> {
    return firstValueFrom(this._http.patch('/Routes/', id, data));
  }
  public delete(id: number): Promise<Category> {
    return firstValueFrom(this._http.delete('/Routes/', id));
  }

}
